import { useParams } from "react-router";
import { Button } from "../../../components/button/button";
import { Rewards } from "../../../components/rewards/rewards";
import { useOpenPage } from "../../../hooks/useOpenPage";
import { workerCardButtons } from "./workerCardButtons";
import { useEffect, useState } from "react";
import { Image } from "../../../components/image/image";
import { levelNames } from "../../../config/levelNames";
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate";
import { Spring } from "../../../components/spring/spring";
import { useConfirmPopup } from "../../../components/popup/confirmPopup/confirmPopup";
import AdminAPI from "../../../api/AdminAPI";
import { DEFAULT_ICON } from "../../../config/constants";

import { Text } from "../../../components/text/text";

import styles from "./workerCardPage.module.css"


export const WorkerCardPage = () => {
    const openPage = useOpenPage();
    const { userId } = useParams();

    const [userData, setUserData] = useState({
        userId: "",
        name: "Загрузка...",
        photo: "",
        cafeId: null,
        level: 1,
        totalExp: 0,
        kpiSchemeId: null,
    });

    useEffect(() => {
        AdminAPI
            .fetchUserInfo(userId)
            .then(res => setUserData(res))
            .catch(console.error);
    }, [userId]);

    const navigate = useAnimatedNavigate();
    const { cafeId } = useParams();
    const onDeleteUser = () => {
        if (!cafeId) return;
        AdminAPI
            .deleteUserFromCafe(cafeId, userId)
            .then(() => {
                navigate(`/admin/${cafeId}/cafe/employees`);
            })
            .catch(console.error);
    }

    const [Popup, open] = useConfirmPopup(
        "Подтвердите действие",
        "Вы уверены, что хотите удалить сотрудника?",
        onDeleteUser
    )

    return (
        <>
            <div className={styles.user_info}>
                <Image className={styles.user_icon} width="80px" height="80px" objectFit="cover" src={userData.photo || DEFAULT_ICON} />
                <Text as="div" variant="body" className={styles.user_name} >
                    {userData.name}
                </Text>
                <div className={styles.user_level}>
                    <Text as="div" variant="h3" className={styles.user_level_title} >Уровень</Text>
                    <Text as="div" variant="body" className={styles.user_level_name} >{levelNames[Math.min(0, userData.level - 1)][0]}</Text>
                </div>
            </div>

            <Rewards userId={userId} />

            <div className={styles.profile_buttons}>
                {
                    workerCardButtons.map((data, i) =>
                        <Button onClick={openPage(data.path)} key={i} text={data.text} type={data.type} icon={data.icon} />
                    )
                }
            </div>

            <Spring />

            <Button
                text="Удалить сотрудника"
                type="semi_destructive"
                onClick={open}
            />

            {Popup}
        </>
    )
}
